import React, {useEffect, useState} from "react";

import VLFModal from "@/components/Modal";
import VLFTextField from "@/components/Input/TextField";
import VLFDatePicker from "@/components/Input/DatePicker";

import {REQUIRED_FIELD} from "@/utils/constants";
import {checkRequiredFields} from "@/utils/functions";

const requiredFields = ["name", "expiryDate"];

const DEFAULT_NAME = "Certificato medico-sportivo agonistico";

function HandleCertificateModal(props) {
	const {open, initialData, confirm, close} = props;

	const [formData, setFormData] = useState({name: DEFAULT_NAME});
	const [errors, setErrors] = useState([]);

	useEffect(() => {
		if (initialData) {
			setFormData(initialData);
		}
	}, [initialData]);

	return (
		<VLFModal
			maxWidth="sm"
			open={open}
			title={initialData ? "Modifica certificato" : "Nuovo certificato"}
			close={close}
			confirm={() => {
				const errors = checkRequiredFields(requiredFields, formData);
				setErrors(errors);

				if (!errors.length) {
					confirm(formData, initialData?.id);
				}
			}}
			content={
				<div className="row">
					<div className="col-xs-12 col-sm-7">
						<VLFTextField
							name="name"
							value={formData.name || ""}
							onChange={(event) => {
								setErrors([]);
								setFormData({...formData, name: event.target.value});
							}}
							label="Tipo"
							required
							helperText={errors.indexOf("name") !== -1 ? REQUIRED_FIELD : ""}
							error={errors.indexOf("name") !== -1}
						/>
					</div>
					<div className="col-xs-12 col-sm-5">
						<VLFDatePicker
							label="Scadenza"
							value={formData.expiryDate}
							onChange={(value) => {
								setErrors([]);
								setFormData({...formData, expiryDate: value});
							}}
							format="DD-MM-YYYY"
							required
							helperText={
								errors.indexOf("expiryDate") !== -1 ? REQUIRED_FIELD : ""
							}
							error={errors.indexOf("expiryDate") !== -1}
						/>
					</div>
				</div>
			}
		/>
	);
}

export default HandleCertificateModal;
